/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardDto } from '../../models/dashboard-dto';

export interface DashboardFavoritesOrganizationGet$Plain$Params {
}

export function dashboardFavoritesOrganizationGet$Plain(http: HttpClient, rootUrl: string, params?: DashboardFavoritesOrganizationGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardFavoritesOrganizationGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DashboardDto>>;
    })
  );
}

dashboardFavoritesOrganizationGet$Plain.PATH = '/dashboard-favorites/organization';
